module.exports = __webpack_public_path__ + "img/facebook.bd946f62.svg";